import React from "react";
import styled from "styled-components";

import arrowRightSmall from "../../assets/images/icons/svg/arrow-small-orange.svg";

const rp = require("request-promise");

const Button = styled.button`
  padding: 26px 30px;
  font-size: 15px;
  color: ${props => (props.active ? "#fff" : "#7f7f7f")};
  font-weight: 700;
  border: none;
  background: transparent;
  cursor: pointer;
  text-transform: uppercase;
  background-color: ${props => (props.active ? "#2d2e30" : "#000")};
  width: 100%;
  text-align: left;
  white-space: nowrap;
  border-right: ${props =>
    props.active ? "1px solid #000" : "1px solid #2d2e30"};

  @media (max-width: 1150px) {
    padding: 26px 15px;
  }

  @media (max-width: 991.98px) {
    padding: 26px 10px;
  }

  img {
    width: 10px;
    margin-left: 10px;
    margin-top: -2px;
    transform: ${props => (props.active ? "rotate(270deg)" : "rotate(90deg)")};
  }

  &.clicked {
    color: ${props => (props.active ? "#fff" : "#ff5000")};
  }

  &:hover {
    color: ${props => (props.active ? "#fff" : "#ff5000")};
  }

  &:focus {
    outline: none;
  }
`;

const SelectWrapper = styled.div`
  z-index: 9;
  font-family: "Roboto Mono";

  ul {
    padding: 12px 6px 6px;
    background-color: #2d2e30;
    margin-right: 10px;
    max-height: 250px;
    overflow-y: scroll;
    padding-right: 5px;

    @media (max-width: 767.98px) {
      padding-right: 0;
      margin: 0;
    }

    li {
      padding: 15px 25px 15px 25px;
      color: #8f9092;
      font-size: 14px;
      cursor: pointer;
      margin-bottom: 1px;

      @media (max-width: 767.98px) {
        padding: 10px;
      }

      &.active {
        color: #fff;
        background-color: #ff5000;
      }

      &:hover:not(.active) {
        color: #fff;
        background-color: #3d3e40;
      }
    }
  }
`;

class Select extends React.Component {
  state = {
    open: false,
    selected: [],
    options: []
  };

  openSelect = () => {
    this.setState({
      open: !this.state.open
    });
  };

  changeParent = () => {
    console.log({ [this.props.type]: this.state.selected });
    this.props.onChange({ [this.props.type]: this.state.selected });
  };

  selectOption = item => {
    if (this.props.isMulti) {
      let selected = [];
      const indexOf = this.state.selected.indexOf(item);

      if (indexOf === -1) {
        selected = [...this.state.selected, item];
      } else {
        selected = this.state.selected.filter(
          filteredItem => filteredItem !== item
        );
      }

      return this.setState(
        {
          selected
        },
        () => {
          this.changeParent();
        }
      );
    }

    return this.setState(
      {
        selected: [item],
        open: false
      },
      () => {
        this.changeParent();
      }
    );
  };

  promiseOptions = (type, query = "") => {
    if (this.props.options.length > 0) {
      return this.setState({
        options: this.props.options
      });
    }

    return new Promise(() => {
      this.setState(
        {
          options: [],
          selected: []
        },
        () => {
          rp({
            json: true,
            uri: `https://api.v1rage.com/wp-json/wp/v2/${
              type === "marka" ? "marki" : type
            }?per_page=100${query}`
          }).then(response => {
            this.setState({
              options: response
            });
          });
        }
      );
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected.length !== this.props.selected.length) {
      this.setState({
        selected: nextProps.selected
      });
    }

    if (nextProps.parent[0] !== this.props.parent[0]) {
      if (nextProps.type === "typnadwozia") {
        console.log(nextProps.parent[0], nextProps.parent[0] === "motocykl");
        nextProps.parent[0].slug === "motocykl"
          ? this.promiseOptions(nextProps.type, "&parent=43")
          : this.promiseOptions(nextProps.type, "&parent=42");
      }

      if (nextProps.type === "marka") {
        nextProps.parent[0].slug === "motocykl"
          ? this.promiseOptions(nextProps.type, "&parent=59")
          : this.promiseOptions(nextProps.type, "&parent=58");
      }
    }
  }

  componentDidMount() {
    this.promiseOptions(this.props.type);
  }

  render() {
    const { open, options } = this.state;
    const { isMulti, label, selected } = this.props;

    return (
      <SelectWrapper>
        <Button
          active={open}
          className={selected.length > 0 ? "clicked" : ""}
          onClick={this.openSelect}
        >
          {!isMulti && selected.length > 0
            ? this.state.options.find(item => item.slug === selected[0].slug)
                .name
            : label}
          <img
            src={arrowRightSmall}
            alt="Icon arrow right orange"
            className="arrow-icon"
          />
        </Button>
        {open &&
          options.length > 0 && (
            <ul>
              {options.map(item => (
                <li
                  className={
                    selected.find(
                      selectedItem => selectedItem.slug === item.slug
                    )
                      ? "active"
                      : ""
                  }
                  onClick={this.selectOption.bind(this, item)}
                  key={item.slug}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          )}
      </SelectWrapper>
    );
  }
}

Select.defaultProps = {
  options: [],
  isMulti: false,
  parent: [],
  selected: []
};

export default Select;
